import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VirtualListComponent } from './virtual-list';

@NgModule({
  imports: [CommonModule],
  exports: [VirtualListComponent],
  declarations: [VirtualListComponent]
})
export class VirtualListModule { }
